// External packages
import { ClassNameValue, twMerge } from 'tailwind-merge';

// Components
import { Input } from 'components/Forms';
import { Icon } from 'components/Icons';

export const SearchField: React.FC<{
  className?: ClassNameValue;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  isDisabled?: boolean;
}> = ({
  className,
  value,
  onChange,
  isDisabled,
  placeholder = 'Pretraži...',
}) => {
  return (
    <div className={twMerge('relative', className)}>
      <Input
        colorScheme="white"
        className="h-8 peer pl-7 w-auto border-gray-300"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={isDisabled}
      />
      <Icon
        name="search"
        className="absolute peer-disabled:text-gray-200 text-gray-500 top-1/2 -translate-y-1/2 left-2"
      />
    </div>
  );
};
